
import { UA_WANGXIAO, UA_GAOZHOGN, UA_XINXUEKE } from './const'
import { DOMAIN_PART_XUEERSI, DOMAIN_PART_XINXUEKE, DOMAIN_PART_VIPX } from './domain'

export const getCurrentUA = () => window.navigator.userAgent.toLowerCase()
export const getCurrentHost = () => window.location.host

/**
 * 返回是否包含ua的布尔值
 * @param {string} ua
 * @returns boolean
 */
export const includesUA = (ua) => {
  if (!ua) throw new Error('includesUA: ua is required')
  const newUA = ua.replace(/(^\s*)|(\s*$)/g, '') // remove space
  const reg = new RegExp('\\b' + newUA + '\\b')
  return reg.test(getCurrentUA())
}

/**
 * 新学科APP
 * @returns   boolean
 */
export const isInXinxuekeApp = () => {
  return includesUA(UA_XINXUEKE)
}

/**
 * 学而思网校App(素质)
 * @returns  boolean
 */
export const isInWangxiaoApp = () => {
  return includesUA(UA_WANGXIAO)
}

/**
 * 高中APP
 * @returns boolean
 */
export const isInGaozhongApp = () => {
  return includesUA(UA_GAOZHOGN)
}

/**
 * 判断是否在 App里面
 * @returns boolean
 */
export const isInApp = () => {
  return isInXinxuekeApp() || isInWangxiaoApp() || isInGaozhongApp()
}

/**
 * xueersi.com域名下面
 */
export const isInXueersiBrowser = () => {
  return getCurrentHost().includes(DOMAIN_PART_XUEERSI)
}

/**
 * xiwang.com域名下面
 */
export const isInXinXuekeBrowser = () => {
  return getCurrentHost().includes(DOMAIN_PART_XINXUEKE)
}

/**
 * vipx.com域名下面
 */
export const isInVIPXBrowser = () => {
  return getCurrentHost().includes(DOMAIN_PART_VIPX)
}

/**
 * query url 转换成 object
 * @param {*} url
 * @returns
 * 例子：queryStringToObject('https://baidu.com?page=1&count=10');
 * {page: '1', count: '10'}
 */
export const queryStringToObject = (url) =>
  [...new URLSearchParams(url.split('?')[1])].reduce(
    // eslint-disable-next-line no-sequences
    (a, [k, v]) => ((a[k] = v), a),
    {}
  )

// 判断是否在app中展示navbar
export function isShowAppNav () {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return false
  } else if (ua.indexOf('miniprogram') !== -1) {
    // 小程序环境，隐藏导航栏
    return false
  }
  // 晓搜题环境，隐藏导航栏
  if (ua.indexOf('qzsearch') !== -1) {
    return false
  }
  // 新学科App
  if (ua && isInXinxuekeApp()) {
    return false
  }
  // 学而思App
  if (ua && isInWangxiaoApp()) {
    return false
  }
  // 高中App
  if (ua && isInGaozhongApp()) {
    return false
  }
  return true
}

/**
 * 修改favicon的icon地址
 * 需要在link中添加class="favicon"
 * @param {string} url
 */
export function setHeadFavicon (url) {
  const head = document.head || document.getElementsByTagName('head')[0]
  const favicon = head.querySelector('link.favicon')
  if (favicon) {
    favicon.href = url
  } else {
    const link = document.createElement('link')
    link.href = url
    link.rel = 'shortcut icon'
    link.className = 'favicon'
    head.appendChild(link)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@xes/trade-toolkit/src/lib.js